import type { EcommerceItem } from '@/utilities/dataLayer/models';
import { pushDataLayer } from '@/utilities/dataLayer/push';

import type { BusinessLine, VehicleType } from '@/constants/dataLayer';
import { DATA_LAYER_EVENTS, ECOMMERCE_CURRENCY, ECOMMERCE_ITEM_BRAND } from '@/constants/dataLayer';

type TrackPurchaseItemInput = {
    item_id: string;
    item_name: string;
    price: number;
    quantity?: number;
    item_brand?: string;
};

type TrackPurchaseParams = {
    transactionId: string;
    value: number;
    fineAmount?: number;
    tollAmount?: number;
    serviceFeeAmount?: number;
    businessLine: BusinessLine;
    items: TrackPurchaseItemInput[];
    vehicle?: {
        type?: VehicleType;
        brand?: string;
        model?: string;
    };
};

const toEcommerceItems = (items: TrackPurchaseItemInput[]): EcommerceItem[] =>
    items.map((item) => ({
        item_id: item.item_id,
        item_name: item.item_name,
        item_brand: item.item_brand ?? ECOMMERCE_ITEM_BRAND,
        price: item.price,
        quantity: item.quantity ?? 1
    }));

export const trackPurchase = ({
    transactionId,
    value,
    fineAmount,
    tollAmount,
    serviceFeeAmount,
    businessLine,
    items,
    vehicle
}: TrackPurchaseParams): void => {
    pushDataLayer({
        event: DATA_LAYER_EVENTS.PURCHASE,
        ecommerce: {
            transaction_id: transactionId,
            value,
            currency: ECOMMERCE_CURRENCY,
            business_line: businessLine,
            ...(fineAmount !== undefined ? { fine_amount: fineAmount } : {}),
            ...(tollAmount !== undefined ? { toll_amount: tollAmount } : {}),
            ...(serviceFeeAmount !== undefined ? { service_fee_amount: serviceFeeAmount } : {}),
            items: toEcommerceItems(items)
        },
        ...(vehicle ? { vehicle } : {})
    });
};
